var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"oddsMessageBox d-flex flex-column justify-center",class:{ oddsMessageBoxF: _vm.favorites }},[(_vm.message)?_c('div',{staticClass:"oddsMessage",class:{ oddsMessageF: _vm.favorites }},[_vm._v(" "+_vm._s(_vm.message)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }